module.exports = __webpack_public_path__ + "img/fan.0d62765a.svg";